<ng-container *ngIf="appState.hasModule(LxmAppModule.Reports)">
  <reports-list-card
    *requiredRights="[UserAction.ViewReports, UserAction.ViewOthersReports]"
  ></reports-list-card>
</ng-container>
